<template>
	<div class="create-page">
		<div class="create-content">
			<el-form ref="form" :model="form" :rules="rules" label-position="top">
				<!-- 申请方信息 -->
				<div class="create-section pb0" v-if="auditStatus != ''">
					<h3>申请方信息：{{ form.applyOrgName }}</h3>
				</div>
				<div class="create-section pb0" v-if="auditStatus != ''">
					<h3>
						索赔状态
						<el-tag type="info">{{ auditStatusMsg }}</el-tag>
						<span class="number-span" v-if="form.serialNumber">编号：{{ form.serialNumber }}</span>
					</h3>
				</div>
				<div class="create-section" v-if="form.repairType != '' && auditStatus == ''">
					<h3>申请方信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机构类型" prop="applyOrgType">
								<el-select v-model="form.applyOrgType" placeholder="请选择" class="full-width" @change="changeApplyOrgType">
									<el-option
										v-for="option in applyOrgTypeOptions"
										:key="option.value"
										:label="option.label"
										:value="option.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div v-if="form.applyOrgType != ''">
							<el-form-item label="1" prop="applyOrgId" class="hidden-label">
								<el-select
									v-model="form.applyOrgId"
									placeholder="请选择"
									class="full-width"
									filterable
									remote
									@change="getApplyUser"
									:remote-method="getApplyList">
									<el-option v-for="option in applyOptions" :key="option.id" :label="option.name" :value="option.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class="claim-user-box" v-if="applyOrgFlag">
						<el-form-item label="索赔管理员" prop="applyOrgId">
							<div class="claim-user" v-if="applyUserList.length > 0" v-for="(item, i) in applyUserList" :key="item.id">
								{{ item.name && item.tel ? `${item.name}/${item.tel}` : item.name || item.tel }}
							</div>
							<div v-if="applyUserList.length == 0">该机构暂无索赔管理员，无法进行索赔申请</div>
						</el-form-item>
					</div>
				</div>
				<!-- 日志 -->
				<div class="create-section log-section" v-if="logList.length > 0">
					<h3>日志</h3>
					<el-table :data="logList" :header-cell-style="{ color: '#444' }">
						<el-table-column prop="createTime" label="时间" width="160"></el-table-column>
						<el-table-column prop="createUsrCompany" label="执行方"></el-table-column>
						<el-table-column prop="createName" label="执行人" width="120"></el-table-column>
						<el-table-column prop="operNotes" label="事件"></el-table-column>
						<el-table-column prop="remark" label="批注"></el-table-column>
					</el-table>
				</div>
				<!-- 基本信息 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>基本信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机型及开发名" prop="repairDevices">
								<el-cascader v-model="form.repairDevices" :options="repairDeviceOptions" :props="{ value: 'id', label: 'name' }"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="机号" prop="repairDeviceNumber">
								<el-input v-model="form.repairDeviceNumber" placeholder="请输入机号"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="grid-box">
						<div>
							<el-form-item label="问题发生日" prop="partsClaimOrders.issueDate">
								<el-date-picker
									v-model="form.partsClaimOrders.issueDate"
									format="yyyy-MM-dd"
									value-format="yyyy-MM-dd"
									type="date"
									:picker-options="pickerOptions"
									placeholder="请选择问题发生日"></el-date-picker>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="订单号" prop="partsClaimOrders.orderNumber">
								<el-input v-model="form.partsClaimOrders.orderNumber" placeholder="请输入内容"></el-input>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="装箱单号" prop="partsClaimOrders.packingSlipNumber">
								<el-input v-model="form.partsClaimOrders.packingSlipNumber" placeholder="请输入内容"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="mr20">
						<el-form-item label="情况说明" prop="partsClaimOrders.situationDescription">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimOrders.situationDescription"></el-input>
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="补充说明栏" prop="partsClaimOrders.additionalNotes">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.partsClaimOrders.additionalNotes"></el-input>
						</el-form-item>
					</div>
				</div>
				<!-- 勾选项 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>勾选项</h3>
					<div class="radio-box">
						<p>事故类型勾选</p>
						<el-radio v-model="form.partsClaimOrders.issueType" label="1" border>开箱不良（发货15个工作日内提交，包装损坏签收单注明）</el-radio>
						<el-radio v-model="form.partsClaimOrders.issueType" label="2" border>品质事故（理光出库后90天以内，且非安装或使用不当造成）</el-radio>
					</div>
					<div class="radio-box" v-if="form.partsClaimOrders.issueType == '1'">
						<p>事故内容勾选</p>
						<el-radio v-model="form.partsClaimOrders.issueDetails" label="1" border>开箱损坏（外包装完好，未使用）</el-radio>
						<el-radio v-model="form.partsClaimOrders.issueDetails" label="2" border>物流损坏（拒收、签收注明）</el-radio>
						<el-radio v-model="form.partsClaimOrders.issueDetails" label="3" border>数量不足（实收数少于装箱单）</el-radio>
						<el-radio v-model="form.partsClaimOrders.issueDetails" label="4" border>数量过剩（实收数大于装箱数）</el-radio>
						<el-radio v-model="form.partsClaimOrders.issueDetails" label="5" border>发错（实收品与装箱单明细不符）</el-radio>
						<el-radio v-model="form.partsClaimOrders.issueDetails" label="6" border>遗漏（未收到装箱单上货品）</el-radio>
						<el-radio v-model="form.partsClaimOrders.issueDetails" label="7" border>其他</el-radio>
					</div>
				</div>
				<!-- 上传附件 -->
				<div class="create-section" v-if="form.applyOrgId != ''">
					<h3>上传附件</h3>
					<!-- 装箱单 -->
					<div class="upload-box">
						<h4>装箱单</h4>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('packing', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="packingListFileIdList"
							list-name="packingListFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
					</div>
					<!-- 故障样张或照片 -->
					<div class="upload-box">
						<h4>故障样张或照片</h4>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('failureSample', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="faultSampleFileIdList"
							list-name="faultSampleFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
					</div>
					<!-- 订购的故障零件，外包装等照片 -->
					<div class="upload-box">
						<h4>订购的故障零件，外包装等照片</h4>
						<el-upload
							:action="action"
							:headers="headers"
							:multiple="true"
							:show-file-list="false"
							:before-upload="handleBeforeUpload"
							:on-error="handleError"
							:on-success="(res, file, list) => handleSuccess('packaging', res, file, list)">
							<el-button icon="el-icon-paperclip">上传文件</el-button>
						</el-upload>
						<FileList
							:file-list="packagingPhotosFileIdList"
							list-name="packagingPhotosFileIdList"
							closable
							@onRemove="handleAttachFileRemove"
							class="mt4"></FileList>
					</div>
				</div>
				<!-- 机器零件信息 -->
				<div class="create-section" v-if="form.repairType != ''">
					<h3>{{ partTitleObj[form.repairType] }}信息</h3>
					<!-- 动态生成的零件信息部分 -->
					<div class="flex part-info-box" v-for="(part, index) in form.partsDetailList" :key="index">
						<div class="flex-1">
							<div class="part-info-item">
								<el-form-item
									:label="`${partTitleObj[form.repairType]}名称`"
									:prop="`partsDetailList.${index}.partsName`"
									:rules="rules.partsDetailList.partsName">
									<el-input v-model="part.partsName" :placeholder="`请输入${partTitleObj[form.repairType]}名称`"></el-input>
								</el-form-item>
								<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
							</div>
							<div class="part-info-item">
								<el-form-item
									:label="`${partTitleObj[form.repairType]}编号`"
									:prop="`partsDetailList.${index}.partsNumber`"
									:rules="rules.partsDetailList.partsNumber">
									<el-input v-model="part.partsNumber" :placeholder="`请输入${partTitleObj[form.repairType]}编号`"></el-input>
								</el-form-item>
								<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
							</div>
							<div class="part-info-item">
								<el-form-item :label="'申请数量'" :prop="`partsDetailList.${index}.partsAmount`" :rules="rules.partsDetailList.partsAmount">
									<el-input v-model="part.partsAmount" placeholder="请输入申请数量"></el-input>
								</el-form-item>
								<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
							</div>
							<div class="delete-btn-box">
								<i class="el-icon-delete-solid" @click="removePartInfo(index)"></i>
							</div>
						</div>
						<div class="flex-1 part-info-box-right"></div>
					</div>
					<el-button type="primary" class="ml20 mt20" @click="addPartInfo">新增{{ partTitleObj[form.repairType] }}</el-button>
				</div>
			</el-form>
		</div>
		<!-- 底部按钮区域 -->
		<div class="create-footer" v-if="form.applyOrgId != ''">
			<div>
				<el-button type="info" @click="handleBack">返回</el-button>
			</div>
			<el-button v-if="form.id" type="danger" @click="handleRevocation">撤销</el-button>
			<el-button type="warning" @click="handleSubmit('0')" v-if="![-22].includes(auditStatus)">暂存</el-button>
			<el-button type="primary" @click="handleSubmit('1')">{{ [-22].includes(auditStatus) ? "重新提交" : "提交" }}</el-button>
		</div>
		<!-- 右侧边固定按钮区域 -->
		<div class="fixed-btn-box" v-if="form.applyOrgId != '' && ![-22].includes(auditStatus)">
			<el-button type="info" @click="handleBack">返回</el-button>
			<el-button v-if="form.id" type="danger" @click="handleRevocation">撤销</el-button>
			<el-button type="warning" @click="handleSubmit('0')">暂存</el-button>
			<el-button type="primary" @click="handleSubmit('1')">提交</el-button>
		</div>
	</div>
</template>

<script>
import { claimOrdersInfo, claimOrdersAuditAdd } from "@/api/claim";
import { debounce } from "@/utils/debounce";
const defaultSettings = require("@/settings.js");
const hostName = defaultSettings.hostName;
import FileList from "../components/FileList.vue";
export default {
	components: {
		FileList,
	},
	data() {
		return {
			// 签约类型
			applyOrgTypeOptions: [
				{
					value: "2",
					label: "特约维修店",
				},
				{
					value: "3",
					label: "代理商",
				},
				{
					value: "4",
					label: "分部",
				},
			],
			// 申请方信息
			applyOptions: [],
			// 申请方人员信息
			applyUserList: [],
			// 机型及开发名
			repairDeviceOptions: [],
			form: {
				repairType: "2", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
				applyOrgType: "", // 申请方信息-机构类型 1、网络店 2、特约维修店 3、代理商 4、分部
				applyOrgId: "", // 申请方信息 对应的机构id
				repairModelId: "", // 机型及开发名 一级
				repairDeviceId: "", // 机型及开发名 二级
				repairDeviceNumber: "", // 机号
				isSubmit: 0, // 是否提交 0否(表示暂存)  1是(提交索赔)
				repairDevices: [],
				//基本信息
				partsClaimOrders: {
					issueDate: "", // 问题发生日
					orderNumber: "", // 订单号
					packingSlipNumber: "", // 装箱单号
					situationDescription: "", // 情况说明
					additionalNotes: "", // 补充说明栏
					issueType: "", // 事故类型 1、开箱不良 2、品质事故
					issueDetails: "", // 事故内容勾选 1、开箱损坏 2、物流损坏 3、数量不足 4、数量过剩 5、发错 6、遗漏 7、其他
					packingListFileIdList: [], //装箱单上传文件的id
					faultSampleFileIdList: [], //故障样张或照片 上传文件的id
					packagingPhotosFileIdList: [], //订购的故障零件，外包装等照片 上传文件的id
				},
				// 机器零件信息
				partsDetailList: [],
			},
			rules: {
				repairDevices: [{ required: true, message: "机型及开发名", trigger: "blur" }],
				repairDeviceNumber: [{ required: true, message: "请输入机号", trigger: "blur" }],
				partsClaimOrders: {
					issueDate: [
						{
							required: true,
							message: "请选择问题发生日",
							trigger: "blur",
						},
					],
					orderNumber: [{ required: true, message: "请输入内容", trigger: "blur" }],
					packingSlipNumber: [{ required: true, message: "请输入内容", trigger: "blur" }],
					situationDescription: [{ required: true, message: "请输入内容", trigger: "blur" }],
				},
				partsDetailList: {
					partsName: [
						{
							required: true,
							message: "请输入订购零件名称",
							trigger: "blur",
						},
					],
					partsNumber: [
						{
							required: true,
							message: "请输入订购零件编号",
							trigger: "blur",
						},
					],
					partsAmount: [
						{
							required: true,
							message: "请输入申请数量",
							trigger: "blur",
						},
						{
							pattern: /^[1-9]\d*$/,
							message: "数量必须为正整数",
							trigger: "blur",
						},
					],
				},
			},
			// 装箱单附件列表
			packingListFileIdList: [],
			// 故障样张或照片附件列表
			faultSampleFileIdList: [],
			// 订购的故障零件，外包装等照片附件列表
			packagingPhotosFileIdList: [],
			// 机器零件列表
			partsDetailList: [],
			// 索赔管理员是否显示
			applyOrgFlag: false,
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			auditStatus: "",
			auditStatusMsg: "",
			pickerOptions: {
				disabledDate(time) {
					// 禁用今天之后的日期（只能选今天及之前）
					return time.getTime() > Date.now();
				},
			},
			logList: [],
		};
	},
	computed: {
		action() {
			return hostName + "bsi/sysAttachFile/addFileOss";
		},
		headers() {
			const token = sessionStorage.getItem("token") || "";
			return {
				token: token,
			};
		},
		// 是否是超级管理员
		isSuperAdmin() {
			const userInfoStr = window.sessionStorage.getItem("userInfo");
			if (!userInfoStr) return false;
			const userInfo = JSON.parse(userInfoStr);
			if (!userInfo) return false;
			if (userInfo.superAdminFlag === "1") return true;
			return false;
		},
	},
	mounted() {
		const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
		// 代理商
		if (userInfo.sysAgent.contractLevel == "1410436558597210114") {
			this.applyOrgTypeOptions = [
				{
					value: "3",
					label: "代理商",
				},
			];
		}
		// 获取机型及开发名
		this.getRepairDevice();
		// 获取单个索赔信息
		const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
		if (claimId) {
			this.getClaimWarrantyInfo(claimId);
			this.getAuditLogList(claimId);
		} else {
			this.form.id ? delete this.form.id : "";
		}
	},
	methods: {
		// 获取审核日志
		getAuditLogList(claimId) {
			let self = this;
			self.$request.post("getAuditLogList", false, { id: claimId }, function (r) {
				if (r.code == "0") {
					let logList = [];
					for (const element of r.data) {
						if (element.remark) {
							logList.push(element);
						}
					}
					self.logList = logList;
					console.log("审核日志", self.logList);
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取单个索赔信息
		getClaimWarrantyInfo(claimId) {
			let self = this;
			claimOrdersInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						self.auditStatus = r.data?.currentAudit?.auditStatus || "";
						self.form.id = r.data.id;
						self.form.repairType = r.data.repairType;
						self.form.applyOrgType = String(r.data.applyOrgType);
						self.form.applyOrgId = r.data.applyOrgId;
						self.form.repairDeviceId = r.data.repairDeviceId;
						self.form.repairDeviceNumber = r.data.repairDeviceNumber;
						self.form.partsClaimOrders = {
							id: r.data.partsClaimOrders.id,
							issueDate: r.data.partsClaimOrders.issueDate, // 问题发生日
							orderNumber: r.data.partsClaimOrders.orderNumber, // 订单号
							packingSlipNumber: r.data.partsClaimOrders.packingSlipNumber, // 装箱单号
							situationDescription: r.data.partsClaimOrders.situationDescription, // 情况说明
							additionalNotes: r.data.partsClaimOrders.additionalNotes, // 补充说明栏
							issueType: String(r.data.partsClaimOrders.issueType), // 事故类型 1、开箱不良 2、品质事故
							issueDetails: String(r.data.partsClaimOrders.issueDetails), // 事故内容勾选 1、开箱损坏 2、物流损坏 3、数量不足 4、数量过剩 5、发错 6、遗漏 7、其他
							packingListFileIdList: [], //装箱单上传文件的id
							faultSampleFileIdList: [], //故障样张或照片上传文件的id
							packagingPhotosFileIdList: [], //订购的故障零件，外包装等照片上传文件的id
						};
						let aa = [];
						for (const element of r.data.partsDetailList) {
							aa.push({
								partsAmount: element.partsAmount,
								partsName: element.partsName,
								partsNumber: element.partsNumber,
							});
						}
						self.form.partsDetailList = [...aa];
						// 申请方公司和人员
						self.getApplyList(r.data.applyOrgName);
						self.getApplyUser();

						// 机型及开发名
						r.data.repairModelId ? (self.form.repairDevices = [r.data.repairModelId, r.data.repairDeviceId]) : [];
						self.packingListFileIdList = r.data.partsClaimOrders.packingListFileList;
						self.faultSampleFileIdList = r.data.partsClaimOrders.faultSampleFileList;
						self.packagingPhotosFileIdList = r.data.partsClaimOrders.packagingPhotosFileList;

						if (r.data.currentAudit) {
							self.form.applyOrgName = r.data.applyOrgName;
							if ([-22].includes(r.data.currentAudit.auditStatus)) {
								self.auditStatusMsg = "材料重新提交";
							}
							self.form.serialNumber = r.data.serialNumber;
						}
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// 变更申请类型
		changeApplyOrgType() {
			this.form.applyOrgId = "";
			this.applyOrgFlag = false;
			this.applyUserList = [];
			this.getApplyList();
		},
		// 获取申请方信息
		getApplyList(query) {
			let self = this;
			const params = { applyOrgType: self.form.applyOrgType };
			if (query) {
				params.nameLike = query;
			}
			self.$request.post("getApplyList", false, params, function (r) {
				if (r.code == "0") {
					self.applyOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取申请方人员信息
		getApplyUser() {
			let self = this;
			const params = { agentId: self.form.applyOrgId };
			self.$request.post("getApplyUser", false, params, function (r) {
				if (r.code == "0") {
					self.applyOrgFlag = true;
					self.applyUserList = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取机型及开发名
		getRepairDevice() {
			let self = this;
			self.$request.get("getRepairDevice", false, {}, function (r) {
				if (r.code == "0") {
					// 删除最后一级的children属性
					for (const element of r.data) {
						for (let index = 0; index < element.children.length; index++) {
							const extAttr = element.children[index];
							delete extAttr.children;
						}
					}
					self.repairDeviceOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 上传前校验
		handleBeforeUpload(file) {
			if (this.isSuperAdmin) {
				// 超管单个文件大小限制1G
				const limitSize = file.size / 1024 / 1024 / 1024 <= 1;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过1G");
					return false;
				}
			} else {
				// 非超管单个文件大小限制255M
				// 2022-07-31 应客户要求改为200M
				const limitSize = file.size / 1024 / 1024 <= 200;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过200M");
					return false;
				}
			}
		},
		// 上传失败回调
		handleError(err, file, fileList) {
			console.log(`handleError`);
			console.log(err);
		},
		// 上传成功回调
		handleSuccess(type, response, file, fileList) {
			if (type === "packing") {
				this.packingListFileIdList.push(file.response.data); // 装箱单
			} else if (type === "failureSample") {
				this.faultSampleFileIdList.push(file.response.data); // 故障样张或照片
			} else if (type === "packaging") {
				this.packagingPhotosFileIdList.push(file.response.data); // 订购的故障零件，外包装等照片
			}
		},
		// 删除上传文件
		handleAttachFileRemove(file, fileListName) {
			this[fileListName].splice(this[fileListName].indexOf(file), 1);
		},
		// 新增机器零件
		addPartInfo() {
			this.form.partsDetailList.push({
				partsName: "",
				partsNumber: "",
				partsAmount: "1",
			});
		},
		// 删除机器零件
		removePartInfo(index) {
			this.form.partsDetailList.splice(index, 1);
		},
		// 返回列表页
		handleBack() {
			this.$router.push({
				path: sessionStorage.getItem("claimRoute"),
			});
		},
		// 暂存/提交  请确认索赔申请资料真实有效以及申请零件在索赔范围内
		handleSubmit: debounce(function (isSubmit) {
			let self = this;
			self.form.isSubmit = isSubmit;
			if (self.form.repairType == "") {
				self.$message.error("索赔类型不能为空");
				return;
			}
			if (self.form.applyOrgType == "" || self.form.applyOrgId == "") {
				self.$message.error("申请方信息不能为空");
				return;
			}
			// 提交
			if (isSubmit == "1") {
				// 该机构暂无索赔管理员，无法进行索赔申请
				if (self.applyUserList.length == 0) {
					self.$message.error("该机构暂无索赔管理员，无法进行索赔申请");
					return;
				}
				// 事故类型
				if (self.form.partsClaimOrders.issueType == "") {
					self.$message.error("请选择事故类型");
					return;
				}
				// 事故内容
				if (self.form.partsClaimOrders.issueType == "1" && self.form.partsClaimOrders.issueDetails == "") {
					self.$message.error("请选择事故内容");
					return;
				}
				// 装箱单
				if (self.packingListFileIdList.length == 0) {
					self.$message.error("请上传装箱单");
					return;
				}
				// 故障样张或照片
				if (self.faultSampleFileIdList.length == 0) {
					self.$message.error("请上传故障样张或照片");
					return;
				}
				// 订购的故障零件，外包装等照片
				if (self.packagingPhotosFileIdList.length == 0) {
					self.$message.error("请上传订购的故障零件，外包装等照片");
					return;
				}
				// 订购零件信息不能为空
				if (self.form.partsDetailList.length == 0) {
					self.$message.error(`${self.partTitleObj[self.form.repairType]}不能为空`);
					return;
				}
				self.$confirm(`请确认索赔申请资料真实有效`, "", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
				})
					.then(() => {
						self.$refs["form"].validate((valid, fields) => {
							if (valid) {
								self.handleForm();
							} else {
								self.$message.error("索赔信息不完整，请完善信息。");
								return false;
							}
						});
					})
					.catch(() => {});
			}
			// 暂存
			else {
				self.handleForm();
			}
		}, 500),
		// 处理form数据
		handleForm() {
			let self = this;
			// 机型及开发名 赋值
			self.form.repairModelId = self.form.repairDevices[0] || "";
			self.form.repairDeviceId = self.form.repairDevices[1] || "";

			self.form.partsClaimOrders.packingListFileIdList = [];
			self.form.partsClaimOrders.faultSampleFileIdList = [];
			self.form.partsClaimOrders.packagingPhotosFileIdList = [];
			if (self.packingListFileIdList.length > 0) {
				for (const element of self.packingListFileIdList) {
					self.form.partsClaimOrders.packingListFileIdList.push(element.id);
				}
			}
			if (self.faultSampleFileIdList.length > 0) {
				for (const element of self.faultSampleFileIdList) {
					self.form.partsClaimOrders.faultSampleFileIdList.push(element.id);
				}
			}
			if (self.packagingPhotosFileIdList.length > 0) {
				for (const element of self.packagingPhotosFileIdList) {
					self.form.partsClaimOrders.packagingPhotosFileIdList.push(element.id);
				}
			}
			console.log("提交数据:", self.form);

			const postUrl = self.form.id ? "updateClaimOrders" : "addClaimOrders";
			// console.log(postUrl);
			// console.log(self.form);
			// return;
			self.$request.post(postUrl, true, self.form, function (r) {
				if (r.code == "0") {
					console.log(self.form.isSubmit);
					if (self.form.isSubmit == "0") {
						if (postUrl == "addClaimOrders") {
							sessionStorage.setItem("claimId", r.data.id);
							self.getClaimWarrantyInfo(r.data.id);
						}
						self.$message({
							message: "暂存成功",
							type: "success",
						});
					} else {
						self.$message({
							message: "操作成功",
							type: "success",
						});
						self.handleBack();
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 撤销
		handleRevocation() {
			this.$confirm(`确认撤销此次索赔吗?`, "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let self = this;
					const params = {
						relatedId: self.form.id,
						auditStatus: "-20",
					};
					claimOrdersAuditAdd(params, true)
						.then((r) => {
							if (r.code == "0") {
								self.$message({
									message: "操作成功",
									type: "success",
								});
								self.handleBack();
							} else {
								self.$message.error(r.msg);
							}
						})
						.catch((error) => {
							console.log(error);
							// 错误处理已在拦截器中统一处理
						});
				})
				.catch(() => {});
		},
	},
};
</script>

<style lang="scss" scoped>
.create-page {
	display: flex;
	flex-direction: column;
}
.create-tab {
	width: 160px;
	border-bottom: 2px solid #409eff;
	text-align: center;
	padding-bottom: 10px;
	margin-bottom: 20px;
}
.create-section {
	padding-bottom: 20px;
	border: 1px solid #ae8d5a;
	border-radius: 8px;
	h3 {
		height: 60px;
		line-height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid #dcdfe6;
	}
}
.type-list {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 20px 20px 0;
	.claim-type {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 34px 20px;
		border-radius: 4px;
		border: 2px solid rgba(0, 0, 0, 0.15);
		font-size: 20px;
		font-weight: 500;
		color: #aaa7a7;
		cursor: pointer;
		.tip {
			margin-top: 10px;
			font-weight: 500;
			font-size: 12px;
			color: #666;
			word-break: break-all;
		}
	}
	.selected {
		border-color: #409eff;
		color: #409eff;
	}
}
.grid-box {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 0 20px;
	.el-cascader,
	.el-date-editor {
		width: 100%;
	}
}
.grid-box1 {
	grid-template-columns: 1fr 2fr; /* 定义列 */
}
/* 使用深度选择器 */
.el-form-item ::v-deep .el-form-item__label {
	padding: 0;
}
.hidden-label ::v-deep .el-form-item__label {
	opacity: 0;
}
.el-form-item1 ::v-deep .el-form-item__label {
	line-height: 20px;
}
.claim-user-box {
	margin: 0 20px;
	button {
		margin-left: 10px;
	}
}
.claim-user {
	color: rgba(0, 0, 0, 0.87);
	border: none;
	cursor: default;
	height: 34px;
	display: inline-flex;
	outline: 0;
	padding: 2px 10px;
	font-size: 0.8125rem;
	box-sizing: border-box;
	transition:
		background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
		box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	align-items: center;
	white-space: nowrap;
	border-radius: 16px;
	vertical-align: middle;
	justify-content: center;
	text-decoration: none;
	background-color: #e0e0e0;
	cursor: pointer;
	img {
		color: transparent;
		width: 100%;
		height: 100%;
		object-fit: cover;
		text-align: center;
		text-indent: 10000px;
	}
}
.radio-box {
	margin: 0 20px;
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
		margin: 10px 0;
	}
	.el-radio {
		display: block;
		margin-left: 0;
		margin-bottom: 10px;
		width: 100%;
	}
	.el-radio.is-bordered + .el-radio.is-bordered {
		margin-left: 0;
	}
}
.el-radio ::v-deep .el-radio__inner {
	width: 20px;
	height: 20px;
}
.el-radio ::v-deep .el-radio__label {
	font-size: 16px;
	color: #000;
}
.upload-box {
	margin: 10px 20px;
	h4,
	p {
		margin-bottom: 10px;
	}
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
	}
}
.upload-box ::v-deep .el-upload-dragger {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 120px;
	width: 120px;
	.el-icon-upload {
		font-size: 40px;
		line-height: unset;
		margin: unset;
	}
}
.create-footer {
	display: flex;
	div {
		flex: 1;
	}
	margin-top: 10px;
}
.fixed-btn-box {
	position: fixed;
	top: 80px;
	right: calc(10vw - 80px);
	button {
		display: block;
		margin-left: 0;
		margin-bottom: 10px;
	}
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
}
.part-info-box {
	margin: 10px 20px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
}
.mt20 {
	margin-top: 20px;
}
.ml20 {
	margin-left: 20px;
}
.color-red {
	color: red;
}
.mr20 {
	margin: 0 20px;
}
.notice {
	color: #409eff;
	display: inline-block;
	text-decoration: underline;
	margin-left: 30px;
	cursor: pointer;
}
iframe {
	width: 100%;
	height: 70vh;
}
.create-page ::v-deep .el-dialog__header {
	display: none;
}
.create-page ::v-deep .el-dialog__body {
	padding: 0;
}
.prepaid-box {
	margin: 10px 20px;
	p {
		margin-bottom: 10px;
	}
}

.number-span {
	float: right;
	font-size: 16px;
	font-weight: normal;
}
.pb0 {
	padding-bottom: 0;
}
.log-section {
	.el-table {
		margin-left: 20px;
		width: calc(100% - 40px);
		margin-top: 20px;
		font-size: 12px;
	}
}
</style>
<style>
.create-tooltip {
	width: 220px;
}
</style>
